var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "client-fields" },
    [
      _c("ExpandableGroupTable", {
        attrs: {
          groups: _vm.sections,
          "expanded-keys": _vm.defaultOpenSectionKeys
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function(ref) {
              var group = ref.group
              return [
                _c(
                  "v-row",
                  _vm._l(group.fields, function(field) {
                    return _c(
                      "v-col",
                      {
                        key: field.id,
                        class: field.wrapperClass,
                        attrs: { cols: field.cols, md: field.md }
                      },
                      [
                        field.kind === "checkboxGroup"
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex az-gap align-center flex-wrap h-100"
                                },
                                _vm._l(field.items, function(item) {
                                  return _c("v-checkbox", {
                                    key: item.id,
                                    attrs: {
                                      "input-value": item.value,
                                      label: item.label
                                    },
                                    on: {
                                      change: function($event) {
                                        return item.onChange($event)
                                      }
                                    }
                                  })
                                }),
                                1
                              )
                            ]
                          : field.kind === "statusToggle"
                          ? [
                              _c("div", { staticClass: "az-text-label" }, [
                                _vm._v(" " + _vm._s(field.label) + " ")
                              ]),
                              _c("BaseToggleButton", {
                                attrs: {
                                  value: field.value,
                                  options: field.options,
                                  small: ""
                                },
                                on: {
                                  input: function($event) {
                                    return field.onChange($event)
                                  }
                                }
                              })
                            ]
                          : field.kind === "accessToggles"
                          ? [
                              _c(
                                "div",
                                { staticClass: "d-flex az-gap flex-wrap mt-4" },
                                _vm._l(field.group.items, function(item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.id,
                                      staticClass: "d-flex flex-column"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "az-text-label mb-1" },
                                        [_vm._v(" " + _vm._s(item.label) + " ")]
                                      ),
                                      _c("BaseToggleButton", {
                                        attrs: {
                                          value: item.value,
                                          options: item.options,
                                          small: ""
                                        },
                                        on: {
                                          input: function($event) {
                                            return item.onChange($event)
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _c("div", { staticClass: "az-text-small mt-1" }, [
                                _vm._v(" " + _vm._s(field.group.hint) + " ")
                              ])
                            ]
                          : field.kind === "tags"
                          ? [
                              _c(
                                "TagsField",
                                _vm._b(
                                  {
                                    on: {
                                      input: function($event) {
                                        return field.onInput($event)
                                      }
                                    }
                                  },
                                  "TagsField",
                                  field.bind,
                                  false
                                )
                              )
                            ]
                          : field.kind === "autocompleteMany"
                          ? [
                              _c("div", { staticClass: "az-text-label" }, [
                                _vm._v(" " + _vm._s(field.label) + " ")
                              ]),
                              _c(
                                "AutocompleteMany",
                                _vm._b(
                                  {
                                    on: {
                                      "update:selected": function($event) {
                                        return field.onUpdateSelected($event)
                                      }
                                    }
                                  },
                                  "AutocompleteMany",
                                  field.bind,
                                  false
                                )
                              )
                            ]
                          : field.kind === "brokerCode"
                          ? [
                              _c("div", { staticClass: "az-text-label" }, [
                                _vm._v(" " + _vm._s(field.label) + " ")
                              ]),
                              _c(
                                "v-text-field",
                                _vm._b(
                                  {
                                    on: {
                                      input: function($event) {
                                        return field.onInput($event)
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        _vm.showBrokerCodeTooltip
                                          ? {
                                              key: "append",
                                              fn: function() {
                                                return [
                                                  _c(
                                                    "v-tooltip",
                                                    {
                                                      attrs: {
                                                        "max-width": "300",
                                                        top: ""
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function(ref) {
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  "v-icon",
                                                                  _vm._g(
                                                                    {
                                                                      attrs: {
                                                                        size:
                                                                          "20"
                                                                      }
                                                                    },
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      " mdi-information-outline "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        [
                                                          _vm._v(
                                                            " Utilize esse código para controle interno "
                                                          ),
                                                          _vm.showPartnershipHint
                                                            ? [
                                                                _vm._v(
                                                                  " ou para fazer o link com clientes que foram importados no módulo de Partnership da plataforma "
                                                                )
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  )
                                                ]
                                              },
                                              proxy: true
                                            }
                                          : null
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-text-field",
                                  field.bind,
                                  false
                                )
                              )
                            ]
                          : field.kind === "select"
                          ? [
                              _c("div", { staticClass: "az-text-label" }, [
                                _vm._v(" " + _vm._s(field.label) + " ")
                              ]),
                              _c(
                                "v-select",
                                _vm._b(
                                  {
                                    on: {
                                      input: function($event) {
                                        return field.onInput($event)
                                      }
                                    }
                                  },
                                  "v-select",
                                  field.bind,
                                  false
                                )
                              )
                            ]
                          : field.kind === "benchmarkPersonalizadoStructured"
                          ? [
                              _c("div", { staticClass: "az-text-label" }, [
                                _vm._v(_vm._s(field.label))
                              ]),
                              _c(
                                "v-radio-group",
                                {
                                  staticClass: "mt-1 mb-2",
                                  attrs: {
                                    value: field.meta.tipo,
                                    row: "",
                                    dense: "",
                                    "hide-details": ""
                                  },
                                  on: {
                                    change: function($event) {
                                      return field.onTipo($event)
                                    }
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Nenhum (usa CDI)",
                                      value: "none"
                                    }
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Pós-fixado: % do indexador",
                                      value: "pos"
                                    }
                                  }),
                                  _c("v-radio", {
                                    attrs: {
                                      label: "Pré-fixado: indexador + spread",
                                      value: "pre"
                                    }
                                  })
                                ],
                                1
                              ),
                              field.meta.tipo !== "none"
                                ? _c(
                                    "v-row",
                                    {
                                      staticClass: "mt-1",
                                      attrs: { "no-gutters": "" }
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pr-2",
                                          attrs: { cols: "6" }
                                        },
                                        [
                                          _c("v-select", {
                                            attrs: {
                                              value: field.meta.indexador,
                                              items: field.indexadores,
                                              label: "Indexador",
                                              outlined: "",
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            on: {
                                              change: function($event) {
                                                return field.onIndexador($event)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c("input-by-type", {
                                            attrs: {
                                              value: field.meta.valor,
                                              type: "decimal",
                                              label: "Valor (%)",
                                              outlined: "",
                                              dense: "",
                                              "hide-details": ""
                                            },
                                            on: {
                                              input: function($event) {
                                                return field.onValor($event)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              field.preview
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "client-fields__benchmark-preview mt-2 mb-1",
                                      class: field.preview.error
                                        ? "error--text"
                                        : "success--text",
                                      staticStyle: { "font-size": "12px" }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(field.preview.message) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "client-fields__benchmark-hint caption grey--text"
                                },
                                [
                                  _vm._v(
                                    " Após salvar, re-cotize o cliente para o benchmark aparecer nos relatórios. "
                                  )
                                ]
                              )
                            ]
                          : [
                              _c("div", { staticClass: "az-text-label" }, [
                                _vm._v(" " + _vm._s(field.label) + " ")
                              ]),
                              _c(
                                "input-by-type",
                                _vm._b(
                                  {
                                    on: {
                                      input: function($event) {
                                        return field.onInput($event)
                                      },
                                      keydown: function($event) {
                                        return _vm.handleFieldKeydown({
                                          field: field,
                                          event: $event
                                        })
                                      }
                                    }
                                  },
                                  "input-by-type",
                                  field.bind,
                                  false
                                )
                              )
                            ]
                      ],
                      2
                    )
                  }),
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }